import { ConnectionError, ServiceUnavailableError, UnauthorizedAccessError } from '../app/errors';
import OutdatedPriceError from './errors';

const POST_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const constructCashInUrl = (betId, slipId) => (
  `${api_config.bet_tracker_api}/bet/${betId}/cashInMyBet?slipId=${slipId}`
);

/* eslint-disable import/prefer-default-export */
export const postCashIn = ({ betId, slipId, betCashInPrice }) => (
  fetch(constructCashInUrl(betId, slipId), {
    method: 'POST',
    headers: POST_HEADERS,
    body: JSON.stringify({ betCashInPrice }),
    credentials: 'include',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      switch (response.status) {
        case 202:
        case 204: {
          return response;
        }
        case 400: {
          throw new UnauthorizedAccessError(response.statusText, response.status);
        }
        case 412: {
          throw new OutdatedPriceError(response.statusText, response.status);
        }
        case 520: {
          throw new ServiceUnavailableError(response.statusText, response.status);
        }
        default: {
          throw new ConnectionError(response.statusText, response.status);
        }
      }
    })
    .then(response => ((response.status === 204) ? { betDelay: 0 } : response.json()))
    .catch(err => {
      throw err;
    })
);
/* eslint-disable import/prefer-default-export */
